import { render, staticRenderFns } from "./voucherDetail.vue?vue&type=template&id=365817bc&"
import script from "./voucherDetail.vue?vue&type=script&lang=js&"
export * from "./voucherDetail.vue?vue&type=script&lang=js&"
import style0 from "./voucherDetail.vue?vue&type=style&index=0&id=365817bc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports